import type { PlanInputFormUsageProduct, ProductInput, PlanInputFormFixedProduct } from '@vy/types';
import { COMMITMENT_TYPES, supportsBasePrice } from '@vy/types';
import { isEmptyString, isNullOrUndefined, isSingleItem, values } from '@vy/utils';
import { omit } from 'lodash';

export function mapProductFormInputToProduct(
  product: PlanInputFormUsageProduct | PlanInputFormFixedProduct,
): ProductInput {
  const currencyCommitment =
    product.commitment?.type === COMMITMENT_TYPES.Price ? product.commitment.amount : undefined;

  const commitment = isNullOrUndefined(product.commitment)
    ? undefined
    : omit(product.commitment, 'autoRefillSync');

  const cloudProviderSettings = product.cloudProviderSettings;
  const cloudProviderSettingsIsEmpty = values(cloudProviderSettings ?? {}).every(isEmptyString);

  const allVariantsSupportBasePrice = product.variants.every((variant) =>
    supportsBasePrice(variant.pricing.pricingModel),
  );
  const basePrice = allVariantsSupportBasePrice ? product.basePrice : undefined;

  // The top-level name is a group name and only applies to grouped (multi-variant)
  // products. Drop it for single-variant products so a stale group name left behind
  // by un-grouping is never persisted and surfaced on invoices (ENG-6069).
  const name = isSingleItem(product.variants) ? undefined : product.name;

  return {
    ...product,
    name,
    basePrice,
    commitment,
    currencyCommitment,
    cloudProviderSettings: cloudProviderSettingsIsEmpty ? null : cloudProviderSettings,
  };
}
